import { render } from "./UserOptions.vue?vue&type=template&id=d9229e00"
import script from "./UserOptions.vue?vue&type=script&lang=js"
export * from "./UserOptions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__